import React from "react";
import "./ContactAndFooter2.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faMapMarkerAlt,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faLinkedin,
  faYoutube,
  faGoogle,
} from "@fortawesome/free-brands-svg-icons";
import { TfiGoogle } from "react-icons/tfi";
import { TfiInstagram } from "react-icons/tfi";
import { ImInstagram } from "react-icons/im";

const ContactAndFooter = () => {
  return (
    <div className="contact-footer">
      {/* Contact Section */}
      <div className="contact-form">
        <h2>Contact Us</h2>
        <hr />
        <h1>Need Help?</h1>
        <h3>Let's Simplify Your Valuation Journey</h3>
        {/* <p>
        Reach our experts for support or start your $109 valuation now.
        </p> */}
        <p>
          Reach out to our team for question, support, or to get started-we're
          here to help.
        </p>
        <form className="form">
          <div className="form-row">
            <input
              type="text"
              className="form-input"
              placeholder="Full Name"
              required
            />
            <input
              type="email"
              className="form-input"
              placeholder="Email"
              required
            />
            <input type="text" className="form-input" placeholder="Website" />
          </div>
          <textarea
            className="form-textarea"
            placeholder="Message"
            rows="5"
          ></textarea>
          <button type="submit" className="form-button">
            SUBMIT
          </button>
        </form>
      </div>

      {/* Footer Section */}
      <footer className="footer">
        <div
          className="footer-content"
          style={{
            backgroundImage: `url("/assets/images/ContactAndFooter/wallpaper2.png")`,
          }}
        >
          <div className="footer-overlay">
            <div className="footer-subitems">
              <div className="footer-item">
                <FontAwesomeIcon icon={faEnvelope} className="footer-icon" />
                <p>info@clybourne.com</p>
              </div>
              <div className="footer-item">
                <FontAwesomeIcon
                  icon={faMapMarkerAlt}
                  className="footer-icon"
                />
                <p>
                  19, 12th Floor, Tower B, Emaar Digital Green <br />
                  Sector-61, Gurgaon-122011
                </p>
              </div>
              <div className="footer-item">
                <FontAwesomeIcon icon={faPhone} className="footer-icon" />
                <p>+91-124-1234567890</p>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>Copyright © 2025 Clybourne</p>
          <div className="social-icons">
            <a href="#">
              <FontAwesomeIcon icon={faFacebookF} className="social-icon" />
            </a>
            <a href="#">
              <FontAwesomeIcon icon={faTwitter} className="social-icon" />
            </a>
            <a href="#">
              {/* <FontAwesomeIcon icon={faGoogle} className="social-icon" /> */}
              <TfiGoogle className="social-icon" />
            </a>
            <a href="#">
              <FontAwesomeIcon icon={faLinkedinIn} className="social-icon" />
            </a>
            <a href="#">
              <ImInstagram className="social-icon" />
            </a>
            <a href="#">
              <FontAwesomeIcon icon={faYoutube} className="social-icon" />
            </a>
          </div>

          <div className="footer-links">
            <a href="#">Privacy Policy</a> | <a href="#">Terms & Conditions</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactAndFooter;
